<template>
<div class="p-0 md:p-5">
  <Loading :isLoading="isLoading" />
  <div class="mb-3">
    <!--padding:14px 14px 0px 0px;font-size:20px;color:#810042;font-weight:700;font-family:Lato;-->
    <p class="cherryColor px-0 py-1 text-xl font-semibold">Inicio</p>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-8 gap-10">

    <!--Tables-->
    <div class="grid grid-cols-1 md:grid-rows-2 gap-5 col-span-8 md:col-span-6">
      
      <div class="md:row-span-3 col-span-2" style="overflow-x:auto;background:#fff;border-width: 1px;border-style: solid;border-color:#FFC300;border-radius:7px;">
        <div class="grid grid-cols-2" style="padding:16px 16px 0 10px;">
          <div style="">
            <router-link to="/analyst/cuenta/solicitudes-ingreso" style="font-size:15px;color:#810042;font-family:lato;font-weight:700;"> Solicitudes Nuevas ({{newRequestsCount}})</router-link>
          </div>
          <div>
            <img src="@/assets/Analyst/setting.svg" alt="setting" style="float:right;">
          </div>
        </div>

        <!--Ag Grid-->
        <TableComponent :key="render.news" :columns="columns.news" :rows="rows.news"  :withStyle="false" />
        <!--End Ag Grid-->
      </div>

      <div class="col-span-2" style="overflow-x:auto;background:#fff;border-width: 1px;border-style: solid;border-color:#FFC300;">
        <div class="grid grid-cols-2" style="padding:16px 16px 0 10px;">
          <div>
            <router-link to="/analyst/solicitudes-en-proceso" style="font-size:15px;color:#810042;font-family:lato;font-weight:700;">Mis Solicitudes en Proceso ({{pendingRequestsCount}})</router-link>
          </div>
          <div>
            <img src="@/assets/Analyst/setting.svg" alt="setting" style="float:right;">
          </div>
        </div>

        <!--Ag Grid-->
        <TableComponent :key="render.inProgress" :columns="columns.inProgress" :rows="rows.inProgress" :withStyle="false" />
        <!--End Ag Grid-->
       </div>
    </div>
    <!--End Tables-->

    <!--Options-->
    <div class="row-start-1 md:row-start-auto grid gap-5 col-span-8 md:col-span-2">
      <!--Mis tareas-->
      <ListCard 
        title="Mis Tareas"
        :pendingRequestsCount="pendingRequestsCount"
        :listTasksIsLoading="listTasksIsLoading" 
        :listRequests="[
          { 
            name: 'Solicitudes en Proceso',
            value: pendingRequestsCount,
            url: '/analyst/solicitudes-en-proceso',
          },
          { 
            name: 'Solicitudes Aceptadas',
            value: aceptedRequestsCount,
            url: '/analyst/cuenta/solicitudes-aceptadas',
          },
          { 
            name: 'Solicitudes Rechazadas',
            value: rejectedRequestsCount,
            url: '/analyst/cuenta/solicitudes-rechazadas',
          },
          { 
            name: 'Solicitudes Asignadas',
            value: assignedRequestsCount,
            url: '#',
          },
          ]"
        />
      
      <!--Solicitudes incompletas-->
      <ListCard 
        classContainer="row-span-1 col-span-1"
        :title="'Solicitudes Incompletas(' + incompleteRequestCount +')'"
        :pendingRequestsCount="pendingRequestsCount"
        :listTasksIsLoading="listTasksIsLoading" 
        :listRequests="[
          { 
            name: 'Solicitudes Incompletas',
            value: incompleteRequestCount,
            url: '/analyst/solicitudes-incompletas',
          },
          ]"
        />
      <!--Solicitudes con pago de inscripción-->
      <ListCard 
        classContainer="row-span-1 col-span-1"
        :title="'Solicitudes con Pago de Inscripción(' + (requestWithRegistrationFee.news + requestWithRegistrationFee.unsigned + requestWithRegistrationFee.signed) +')'"
        :pendingRequestsCount="pendingRequestsCount"
        :listTasksIsLoading="listTasksIsLoading" 
        :listRequests="[
          { 
            name: 'Nuevas',
            value: requestWithRegistrationFee.news,
            url: '/analyst/pagos/inscripcion/categoria/nuevos',
          },
          { 
            name: 'Pendientes de Firma',
            value: requestWithRegistrationFee.unsigned,
            url: '/analyst/pagos/inscripcion/categoria/no-firmados',
          },
          { 
            name: 'Firmados',
            value: requestWithRegistrationFee.signed,
            url: '/analyst/pagos/inscripcion/firmados',
          },
          ]"
        />

      <!--Solicitudes con pago de aportación-->

      <ListCard 
        classContainer="row-span-1 col-span-1"
        :title="'Solicitudes con Pago de Aportación(' + (requestWithRegistrationPaymentSigned.news + requestWithRegistrationPaymentSigned.unsigned + requestWithRegistrationPaymentSigned.signed) +')'"
        :pendingRequestsCount="pendingRequestsCount"
        :listTasksIsLoading="listTasksIsLoading" 
        :listRequests="[
          { 
            name: 'Nuevas',
            value: requestWithRegistrationPaymentSigned.news,
            url: '/analyst/pagos/aportacion/categoria/nuevos',
          },
          { 
            name: 'Pendientes de Firma',
            value: requestWithRegistrationPaymentSigned.unsigned,
            url: '/analyst/pagos/aportacion/categoria/no-firmados',
          },
          { 
            name: 'Firmados',
            value: requestWithRegistrationPaymentSigned.signed,
            url: '/analyst/pagos/aportacion/firmados',
          },
          ]"
        />
    </div>
    <!--End Options-->
  </div>
</div>
</template>

<script>
import { onMounted, onBeforeMount, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';

import Header from "@/components/Analyst/Header.vue"
import MenuLateral from '@/components/Analyst/MenuLateral.vue'
import Loading from '@/components/Loading/VueLoading.vue'

import {getRangeOfDatesByYears} from '@/helpers/dates'
import "@/assets/css/tailwind.css";
import {getTokenDecoden} from "@/helpers/tokenauth";

import TableComponent from "@/components/Forms/Tables/TableComponent";
import ListCard from "@/components/Forms/Cards/ListCard";

import AffiliatedRequest from "@/classes/Affiliated";
import AdmissionRequest from "@/classes/AdmissionRequest";

export default {
  
  name: 'PaginaPrincipal',
  
  setup() {
      
    const apiToken = ref("");
    const personId = ref("");
    const isLoading = ref(true);
    const newRequests = ref([]);
    const newRequestsCount = ref(0);
    const allNewRequests = ref([]);
    const allPendingRequests = ref([]);
    const rejectedRequests = ref([]);
    const aceptedRequests = ref([]);
    const assignedRequests = ref([]);
    const rangeOfYearRequestWithPayment = ref([]);
    const affiliatedObject = ref(null);
    const admissionObject = ref(null);
    const router = useRouter();
    const requestWithRegistrationPayment = ref([]);
    const assignedRequestsCount = ref("-");
    const pendingRequestsCount = ref("-");
    const listTasksIsLoading = ref(false);
    const aceptedRequestsCount = ref("-");
    const rejectedRequestsCount = ref("-");
    const pendingRequests = ref([]);
    const incompleteRequestCount = ref("-");
    const requests = ref([]);
    const showDiv = ref(false);

    const requestWithRegistrationFee = ref({
      news: "-",
      signed: "-",
      unsigned: "-"
    });

    const requestWithRegistrationPaymentSigned = ref({
      news: "-",
      signed: "-",
      unsigned: "-"
    });

    let app = getCurrentInstance();
    const columns = ref({
      news: [],
      inProgress: [],
      paid: []
    });

    const rows = ref({
      news: [],
      inProgress: [],
      paid: []
    });

    const render = ref({
      news: false,
      inProgress: false,
      paid: false
    });

    onMounted(async() => {

      loadInfo();
      app = app.appContext.config.globalProperties;
      affiliatedObject.value = new AffiliatedRequest();
      admissionObject.value = new AdmissionRequest();

      isLoading.value = true;
      getRequests();
      rangeOfYearRequestWithPayment.value = getRangeOfDatesByYears(7);
      getColumnsNews();

      await getRequestsWithRegistrationFee();
      await getApplicationsWithRegistrationPaymentSigned();
      await getRequestsWithContributionFee();
      await getListContractSavingsSignedDocument();

      isLoading.value = false;

    });

    const getApplicationsWithRegistrationPaymentSigned = async () => {
      await admissionObject.value.getApplicationsWithRegistrationPaymentSigned(apiToken.value).then((resp) => {
        requestWithRegistrationFee.value.signed = resp.data.response.requests.length;
      }).catch((err)=>{
        console.log("Error", err);
        isLoading.value = false;
      });
    }

    const getListContractSavingsSignedDocument = async () => {
      await admissionObject.value.getListContractSavingsSignedDocument(apiToken.value).then((resp) => {
        requestWithRegistrationPaymentSigned.value.signed = resp.data.response.result.length;
      }).catch((err)=>{
        console.log("Error", err);
        isLoading.value = false;
      });
    }

    const convertListToArray = (list) => {
      let index = [];
      let array = [];
      for (var i in list) {
        index.push(i);
      }

      for (let i = 0; i < index.length; i++) {
        array.push(list[index[i]]);
      }

      return array;
    };

    const showDivLoading = () => {
      showDiv.value = true;
    }
    const hideDivLoading = () => {
      showDiv.value = false;
    }

    const loadInfo = () => {
      var auth =getTokenDecoden();
      apiToken.value = sessionStorage.getItem("login");
      personId.value = auth.obj.personnel_info['id'];
    }

    const getFinalArrayList = (array) => {
      let finalArray = [];
      if(array == undefined){
        return finalArray;
      }

      for (let i = 0; i < array.length; i++) {
        let contact_info = convertListToArray(array[i].admission_information.contact_info_attributes);

        finalArray.push({
          id: array[i].id,
          rfc: array[i].admission_information.rfc,
          name: app.$filters.formatCamelize(`${array[i].admission_information.name} ${array[i].admission_information.paternal_name}`),
          phone: app.$filters.formatPhone(contact_info.filter(({contact_type}) => contact_type === 'celular').length > 0 ? contact_info.filter(({contact_type}) => contact_type === 'celular')[0].value : "1111111111"),
          email: contact_info.filter(({contact_type}) => contact_type === 'correo').length > 0 ? contact_info.filter(({contact_type}) => contact_type === 'correo')[0].value : "correo@gmail.com",
          date : app.$filters.formatDate(array[i].created_at),
          status: array[i].status,
          date_enroll_payment_fee: array[i].admission_information.enrollment_fee_payment_date,
          method_enroll_payment_fee: array[i].admission_information.enrollment_fee_method,
          actions: array[i].id,
          organization: array[i].person.user.organization_list.join(),
          entidad: array[i].admission_information.workplace_attributes.state
        });
      }
      return finalArray;
    }

    const getAcceptedRequests = async () => {
      aceptedRequestsCountIsLoading.value = true;
      await affiliatedObject.value.getNewRequests(apiToken.value, "aceptada").then(response => {
        aceptedRequests.value = response.data.response.admission_request;
        aceptedRequestsCount.value = aceptedRequests.value.length;
        
      }).catch(err => {
        console.log("Error", err);
        aceptedRequests.value = [];
        aceptedRequestsCount.value = 0;
      });
    }

    const getRejectedRequests = async () => {
      await affiliatedObject.value.getNewRequests(apiToken.value, "rechazada").then(response => {
        rejectedRequests.value = response.data.response.admission_request;
        rejectedRequestsCount.value = rejectedRequests.value.length;ç

      }).catch(err => {
        console.log("Error", err);
        rejectedRequests.value = [];
        rejectedRequestsCount.value = 0;
      });
    }

    const getColumnsNews = () => {
        columns.value.news = [
          { headerName: "RFC", field: "rfc"},
          { headerName: "Nombre", field: "name" },
          { headerName: "Teléfono", field: "phone" },
          { headerName: "Correo", field: "email" },
          { headerName: "Fecha de registro", field: "date" },
          { headerName: "Organización", field: "organization" },
          { headerName: "Entidad", field: "entidad" },
          { headerName: "Acciones", field: "actions", filter: false, cellRenderer: params => {
              const input = document.createElement("label");
              input.innerText = "Asignar";
              input.className += "bg-cherryColor text-white focus:bg-blue-700 px-10 py-1.5 mx-auto rounded-md cursor-pointer text-base";
              input.addEventListener("click", e => {
                e.preventDefault();
                assign(params.value);
              });
              return input;
            }
          }
        ];
    }
    
    const getColumnsInProgress = () => {
        columns.value.inProgress = [
          { headerName: "RFC", field: "rfc"},
          { headerName: "Nombre", field: "name" },
          { headerName: "Teléfono", field: "phone" },
          { headerName: "Correo", field: "email" },
          { headerName: "Fecha de registro", field: "date" },
          { headerName: "Organización", field: "organization" },
          { headerName: "Entidad", field: "entidad" },
          { headerName: "Acciones", field: "actions", filter: false, cellRenderer: params => {
              const route = {
                path: "/analyst/cuenta/revision-solicitudes-ingreso/"+params.value
              };

              const link = document.createElement("a");
              link.href = router.resolve(route).href;
              link.innerText = "Ver";
              link.className += "bg-cherryColor text-white focus:bg-blue-700 px-10 py-1.5 mx-auto rounded-md cursor-pointer text-base";
              link.addEventListener("click", e => {
                e.preventDefault();
                router.push(route);
              });
              return link;
            }
          }
        ];
    }

    const getColumnsPaid = () => {
        columns.value.paid = [
          { headerName: "RFC", field: "rfc"},
          { headerName: "Estatus", field: "status" },
          { headerName: "Fecha de pago", field: "date_enroll_payment_fee" },
          { headerName: "Metodo de pago", field: "method_enroll_payment_fee" },
          { headerName: "Acciones", field: "actions", filter: false, cellRenderer: params => {
              const route = {
                path: "/analyst/cuenta/revision-solicitudes-ingreso/"+params.value
              };

              const link = document.createElement("a");
              link.href = router.resolve(route).href;
              link.innerText = "Ver";
              link.className += "bg-cherryColor text-white focus:bg-blue-700 px-10 py-1.5 mx-auto rounded-md cursor-pointer text-base";
              link.addEventListener("click", e => {
                e.preventDefault();
                router.push(route);
              });
              return link;
            }
          }
        ];
    }

    const getRequests = async() => {  
      
      pendingRequests.value = [];
      rows.value.inProgress = [];
      render.value.inProgress = false;
      listTasksIsLoading.value = true;

      await affiliatedObject.value.getPendingRequests(apiToken.value, personId.value).then(response => {
        let finalArray = getFinalArrayList(response.data.response.admission_request);
        
        allPendingRequests.value = finalArray.filter(request => request.status.toLowerCase() === "en_revision").reverse();
        pendingRequests.value = allPendingRequests.value;
        setTimeout(() => {
          pendingRequestsCount.value = allPendingRequests.value.length;
          aceptedRequestsCount.value = aceptedRequests.value.length;
          rejectedRequestsCount.value = rejectedRequests.value.length;
          assignedRequestsCount.value = allPendingRequests.value.length;
          
          listTasksIsLoading.value = false;
        }, 2000)

        getColumnsInProgress();
        rows.value.inProgress = pendingRequests.value;
        render.value.inProgress = true;
      
        aceptedRequests.value = finalArray.filter(request => request.status.toLowerCase() === "aceptada");

        rejectedRequests.value = finalArray.filter(request => request.status.toLowerCase() === "rechazada");

        assignedRequests.value = finalArray.filter(request => request.status.toLowerCase() === "asignada");

        requests.value = finalArray;
        getNewRequests();
        getIncompleteRequests();
        getRequestWithRegistrationPayment();

      }).catch(err => {
        console.log("Error", err);
        getNewRequests();
        getIncompleteRequests();
      });
    }

    const getRequestWithRegistrationPayment = async () => {

      rows.value.paid = [];
      render.value.paid = false;
      requestWithRegistrationPayment.value = [];
      await admissionObject.value.getListPendingReviewWithPayment(apiToken.value).then(response =>{
        requestWithRegistrationPayment.value = response.data.response.data.reverse();
        let request = requestWithRegistrationPayment.value.map(value => {
          return {
            id: value.id,
            rfc: value.admission_information.rfc,
            status: app.$filters.requestStatus(value.status),
            created_at: app.$filters.formatDate(value.created_at),
            date_enroll_payment_fee: app.$filters.formatDate(value.date_enroll_payment_fee),
            actions: value.id
          }
        });
        getColumnsPaid();
        rows.value.paid = request;
        render.value.paid = true;
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
        requestWithRegistrationPayment.value = [];
      });
    }

    const getNewRequests = async () => {
      
      rows.value.news = [];
      render.value.news = false;
      await affiliatedObject.value.getNewRequests(apiToken.value, "pendiente_de_revision").then(response => {
        let finalArray = getFinalArrayList(response.data.response.admission_request);
        allNewRequests.value = finalArray.reverse();
        newRequests.value = allNewRequests.value;
        newRequestsCount.value = allNewRequests.value.length;
        
        rows.value.news = newRequests.value;
        render.value.news = true;
        isLoading.value = false;
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
        newRequests.value = [];
        newRequestsCount.value = 0;
        render.value.news = true;
      });
    }
    
    

    const getIncompleteRequests = async () => {
      admissionObject.value.getUnfinishedRequest(apiToken.value).then(response => {
        incompleteRequestCount.value = response.data.response.data.length;
      }).catch(err => {
        console.log("Error", err);
      })
    }
    
    const getAssignedRequests = async() => {
      assignedRequests.value = [];
      await affiliatedObject.value.getNewRequests(apiToken.value, "asignada").then(response => {
        assignedRequests.value = response.data.response.admission_request;
        assignedRequestsCount.value = assignedRequests.value.length;
      }).catch(err => {
        console.log("Error", err);
        assignedRequests.value = [];
        assignedRequestsCount.value = 0;
      });
    }

    const assign = async (idRequest) => {
      var swal = require('sweetalert2');
      isLoading.value = true;

      await admissionObject.value.assingAnalystLogged(apiToken.value, personId.value, idRequest).then(() => {
        getRequests().then(() => {
          swal.fire({
            title: "Aviso",
            text: "La solicitud fue asignada a un asociado correctamente",
            icon: "success",
            confirmButtonColor: '#FEB72B',
          });
          isLoading.value = false;
        });
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
      });
    }

    const getRequestsWithRegistrationFee = async () => {
      await admissionObject.value.getRequestsWithRegistrationFee(apiToken.value).then((resp)=>{
        if(!resp.data.response.has_errors){
          const news = resp.data.response.requests.filter(row => row.last_certificate_delivery_date == null);
          const unsigned = resp.data.response.requests.filter(row => row.last_certificate_delivery_date !== null);
          requestWithRegistrationFee.value.news = news.length;
          requestWithRegistrationFee.value.unsigned = unsigned.length;
        }
        isLoading.value = false;
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
      });    
    }

    const getRequestsWithContributionFee = async () => {
      await admissionObject.value.getListContractSavingsDocumentsUnsigned(apiToken.value).then((resp)=>{
        if(!resp.data.response.has_errors){
          const news = resp.data.response.result.filter(row => row.last_contract_send_date == null);
          const unsigned = resp.data.response.result.filter(row => row.last_contract_send_date !== null);
          requestWithRegistrationPaymentSigned.value.news = news.length;
          requestWithRegistrationPaymentSigned.value.unsigned = unsigned.length;
        }
        isLoading.value = false;
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
      });    
    }

    const redirect = (requestId) => {
      router.push({path:"/analyst/cuenta/revision-solicitudes-ingreso/"+requestId});
    }

    return {
      getAssignedRequests,
      assign,
      redirect,
      getAcceptedRequests,
      getRejectedRequests,
      showDivLoading,
      hideDivLoading,
      showDiv,
      columns,
      rows,
      render,
      listTasksIsLoading,
      assignedRequestsCount,
      pendingRequestsCount,
      newRequests,
      aceptedRequestsCount,
      rejectedRequestsCount,
      incompleteRequestCount,
      pendingRequests,
      rangeOfYearRequestWithPayment,
      newRequestsCount,
      requestWithRegistrationFee,
      requestWithRegistrationPaymentSigned,
      isLoading
    }
  },
  components: {
    Header,
    Loading,
    ListCard,
    MenuLateral,
    TableComponent
  },
}
</script>

<style scoped>
table, th, td {
  border-collapse: collapse;
}

.width200 th, td {
  padding: 15px 10px 15px 10px !important;
}

.requestWithRegistrationPayment, th, td {
  padding: 2px 10px 2px 10px;
}

table, th, td {
  border-bottom: 1px solid #85C875;
}
table thead tr th {
  border-bottom: 1px solid #85C875 !important;
}
tr {
  color: #174A84;
  font-size: 12px;
  font-family:lato;
  
}
#menu ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    font-family: Arial, sans-serif;
    font-size: 11pt;
}

#menu ul {
  width: 100%;
}
#menu ul li {
  font-family: "Lato";

  border-bottom: 1px solid #FFC300;
  color:#810042;
  display: block; 
  padding-bottom: 6px;
  padding-top: 9px;
  padding-left: 20px;
  padding-right: 20px;
}
.buttonFilter {
  border: none;
  border-radius: 5px;
  color: #174A84;
  font-weight:bold;
  padding: 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  widows: 10px;
  width:70px;
  cursor: pointer;
  margin-left: 10px;
  background-color: #dbe9f9;
}
.button {
    border: none !important;
    border-radius: 5px !important;
    color: white !important;
    padding: 1px 32px !important;
    text-align: center !important;
    text-decoration: none !important;
    display: inline-block !important;
    font-family:lato !important;
    font-size: 13px !important;
    widows: 10px !important;
    cursor: pointer !important;
    background-color: #174A84 !important;
}
input[type="text"] {
    width: 200px;
    height: 20px;
}
/* Sort Table */
.arrow_down {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAaCAYAAABPY4eKAAAAAXNSR0IArs4c6QAAAvlJREFUSA29Vk1PGlEUHQaiiewslpUJiyYs2yb9AyRuJGm7c0VJoFXSX9A0sSZN04ULF12YEBQDhMCuSZOm1FhTiLY2Rky0QPlQBLRUsICoIN/0PCsGyox26NC3eTNn3r3n3TvnvvsE1PkwGo3yUqkkEQqFgw2Mz7lWqwng7ztN06mxsTEv8U0Aam5u7r5EInkplUol/f391wAJCc7nEAgE9Uwmkzo4OPiJMa1Wq6cFs7Ozt0H6RqlUDmJXfPIx+qrX69Ti4mIyHA5r6Wq1egND+j+IyW6QAUoul18XiUTDNHaSyGazKcZtdgk8wqhUKh9o/OMvsVgsfHJy0iWqVrcQNRUMBnd6enqc9MjISAmRP3e73T9al3XnbWNjIw2+KY1Gc3imsNHR0YV4PP5+d3e32h3K316TySQFoX2WyWR2glzIO5fLTSD6IElLNwbqnFpbWyO/96lCoai0cZjN5kfYQAYi5H34fL6cxWIZbya9iJyAhULBHAqFVlMpfsV/fHxMeb3er+Vy+VUzeduzwWC45XA4dlD/vEXvdDrj8DvURsYEWK3WF4FA4JQP9mg0WrHZbEYmnpa0NxYgPVObm5teiLABdTQT8a6vrwdRWhOcHMzMzCiXlpb2/yV6qDttMpkeshEzRk4Wo/bfoe4X9vb2amzGl+HoXNT29vZqsVi0sK1jJScG+Xx+HGkL4Tew2TPi5zUdQQt9otPpuBk3e0TaHmMDh1zS7/f780S0zX6Yni+NnBj09fUZUfvudDrNZN+GkQbl8Xi8RLRtHzsB9Hr9nfn5+SjSeWUCXC7XPq5kw53wsNogjZNohYXL2EljstvtrAL70/mVaW8Y4OidRO1/gwgbUMvcqGmcDc9aPvD1gnTeQ+0nmaInokRj0nHh+uvIiVOtVvt2a2vLv7Ky0tL3cRTXIcpPAwMDpq6R4/JXE4vFQ5FI5CN+QTaRSFCYc8vLy1l0rge4ARe5kJ/d27kYkLXoy2Jo4C7K8CZOsEBvb+9rlUp1xNXPL7v3IDwxvPD6AAAAAElFTkSuQmCC')
}
.arrow_up {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAAAXNSR0IArs4c6QAAAwpJREFUSA21Vt1PUmEYP4dvkQ8JFMwtBRocWAkDbiqXrUWXzU1rrTt0bdVqXbb1tbW16C9IBUSmm27cODdneoXjputa6069qwuW6IIBIdLvdaF4OAcOiGeDc87zPs/vd57P96WpFq7p6enbGo1mjKZpeTabjU1MTCRagGnOZHFxcXxtbe1XKpUq7+zslJeXl//Mz8+Hy+Uy3RxSE9qTk5M3otFooVQqgef4Wl9f343FYoEmoISrxuNxFX5f9vb2jhn/PxUKhfLS0tIPfFifUESRUMV8Pv/M6XReRm5rTGQyGeXxeGxYe1ezeBpBOBx2rKysbO7v79d4Wy3Y2Nj4GQqFbgnhaugxwiuGJx99Pp9FLBbXxYTXvTqd7v3MzIy6riIWGxJnMpl7AwMD14xGYyMsSq1WUyQdUqn0eSPlusQIsbGrq+vl4OCgvhFQZd1utyv1en0gEolcqsi47nWJlUrlG5fLZVcoFFy2nDKSDpIWlUoVTCQSEk4lCHmJMZ2GTCbTiMVikfIZ88l7enoos9l8dXt7+z6fDicxSJUokqDX6xXcl2wCROoc0vQCWL3sNfLOSdzR0fHY4XC4tVotl40gmVwup9xuN4OQv+UyqCFGH9rg7SOGYVRcBs3IEG4J0nVnamrqOtvuBDGGgQg9+wHFcVEi4a0LNkbdd6TrPKo8ODc311mteIIYjT/a398/jK+s1jnVM0kXoufCFvq0GuiIGEVgQIhfoygM1QrteEa9dAL7ITiYCt4RMabOK5AyKKzKWtvupLcRciu8D5J0EuDDPyT/Snd39yh6VtY2NhYQSR9G79Ds7OxdskRjEyAufvb7/cPoO5Z6e1+xtVKrq6vfcFzyi/A3ZrPZ3GdNSlwgo5ekE4X2RIQGf2C1WlufFE0GBeGWYQ8YERWLxQtnUVB830MKLZfL9RHir8lkssCn2G751tZWEWe03zTKm15YWPiEiXXTYDB0Ig/t7yd8PRws4EicwWHxO4jHD8/C5HiTTqd1BwcHFozKU89origB+y/kmzgYpgOBQP4fGmUiZmJ+WNgAAAAASUVORK5CYII=')
}
.arrow {
  float: right;
  width: 12px;
  height: 15px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position-y: bottom;
}
th.active {
  color: #000;
}
th.active .arrow {
  opacity: 1;
}
.arrow {
  display: block;
  width: 0;
  height: 0;
  margin-left: 0px;
  margin-top:7px;
  opacity: 0.66;
}
.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #174A84;
}
.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #174A84;
}
.arrow-right {
  background: #000;
  height: 3px;
  width: 30px;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
}
#buttonSearch{
  font-family:lato;
}
@media screen and (max-width: 960px) {
  #buttonSearch{
    width: 150px;
  }
}

@media only screen and (max-width: 1024px)  
{
  table.width200, .width200 thead, .width200 tbody, .width200 th, .width200 td, .width200 tr { display: block; }
  
  .width200 thead tr { position: absolute;top: -9999px;left: -9999px; }
  
  .width200 tr { border: 1px solid #4CAF50; }
  
  .width200 td { border: none;border-bottom: 1px solid #4CAF50; position: relative;padding-left: 40%;text-align:left }
  
  .width200 td:before {  top: 6px; width: 45%; white-space: nowrap;}

  .width200 td:nth-of-type(1):before { content: "R.F.C.:"; color: #174A84; font-weight: bold; }
  .width200 td:nth-of-type(2):before { content: "Nombre:"; color: #174A84; font-weight: bold;}
  .width200 td:nth-of-type(3):before { content: "Teléfono:"; color: #174A84; font-weight: bold;}
  .width200 td:nth-of-type(4):before { content: "Correo:"; color: #174A84; font-weight: bold;}
  .width200 td:nth-of-type(5):before { content: "Fecha de Registro:"; color: #174A84; font-weight: bold;}
  
  .descarto {display:none;}
  .fontsize {font-size:10px}
}

@media only screen and (max-width: 1024px)  
{
  table.requestWithRegistrationPayment, .requestWithRegistrationPayment thead, .requestWithRegistrationPayment tbody, .requestWithRegistrationPayment th, .requestWithRegistrationPayment td, .requestWithRegistrationPayment tr { display: block; }
  
  .requestWithRegistrationPayment thead tr { position: absolute;top: -9999px;left: -9999px; }
  
  .requestWithRegistrationPayment tr { border: 1px solid #4CAF50; }
  
  .requestWithRegistrationPayment td { border: none;border-bottom: 1px solid #4CAF50; position: relative;padding-left: 40%;text-align:left }
  
  .requestWithRegistrationPayment td:before {  top: 6px; width: 45%; white-space: nowrap;}

  .requestWithRegistrationPayment td:nth-of-type(1):before { content: "R.F.C.:"; color: #174A84; font-weight: bold; }
  .requestWithRegistrationPayment td:nth-of-type(2):before { content: "Estatus:"; color: #174A84; font-weight: bold;}
  .requestWithRegistrationPayment td:nth-of-type(3):before { content: "Fecha de pago:"; color: #174A84; font-weight: bold;}
  .requestWithRegistrationPayment td:nth-of-type(4):before { content: "Metodo de pago:"; color: #174A84; font-weight: bold;}
  
  .descarto {display:none;}
  .fontsize {font-size:10px}
}

</style>